/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { ADD_EXAM } from "./actionTypes"
import { apiError, addExamSuccess } from "./actions"

//Include Both Helper File with needed methods
import { addExam } from "../../../helpers/backend_helper"

function* add(request) {
  try {
    const response = yield call(addExam, request.payload.form)
    if (response == undefined) throw new Error("API error")
    yield put(addExamSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(apiError(error.message))
  }
}

function* examAddSaga() {
  yield takeEvery(ADD_EXAM, add)
}

export default examAddSaga
